// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__hWiGy","empty":"ModalGraph_empty__2_eJ5"};